var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGithubPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 127",
    style: {
      fill: "none",
      opacity: 0.502
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 .5a9.913 9.913 0 0 0-10 9.827 9.843 9.843 0 0 0 6.837 9.323c.5.093.683-.212.683-.472 0-.233-.008-.852-.013-1.671-2.78.593-3.367-1.319-3.367-1.319a2.619 2.619 0 0 0-1.112-1.438c-.906-.609.07-.6.07-.6a2.092 2.092 0 0 1 1.532 1.012 2.153 2.153 0 0 0 2.912.818 2.081 2.081 0 0 1 .633-1.314c-2.221-.242-4.555-1.087-4.555-4.852a3.754 3.754 0 0 1 1.029-2.636 3.438 3.438 0 0 1 .088-2.6s.838-.263 2.75 1.008a9.588 9.588 0 0 1 5 0c1.9-1.271 2.738-1.007 2.738-1.007a3.533 3.533 0 0 1 .1 2.6 3.77 3.77 0 0 1 1.025 2.637c0 3.775-2.337 4.606-4.562 4.847a2.332 2.332 0 0 1 .675 1.818c0 1.315-.013 2.372-.013 2.691 0 .257.175.565.688.467A9.813 9.813 0 0 0 20 10.327 9.915 9.915 0 0 0 10 .5z",
    transform: "translate(2 1.917)",
    style: {
      fill: "#0222ba"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGithubPrimary);
export default __webpack_public_path__ + "static/media/icon-github-primary.116b7301ab61a2d1797ba104b227225c.svg";
export { ForwardRef as ReactComponent };